import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import AdminSidebar, { MobileMenuButton } from './AdminSidebar';

export default function AdminLayout() {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    authAPI.checkAdminAuth().then(r => {
      if (!r.authenticated) navigate('/admin');
      else setAuthChecked(true);
    });
  }, [navigate]);

  if (!authChecked) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-gray-400 text-sm">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <AdminSidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(c => !c)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Mobile top bar */}
      <div className="lg:hidden sticky top-0 z-30 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 py-3 flex items-center gap-3">
        <MobileMenuButton onClick={() => setMobileOpen(true)} />
        <span className="font-semibold text-gray-900 dark:text-white text-sm">SAS Admin</span>
      </div>

      {/* Main content */}
      <main className={`transition-all duration-200 ${collapsed ? 'lg:pl-16' : 'lg:pl-56'}`}>
        <Outlet />
      </main>
    </div>
  );
}
